module.exports = __webpack_public_path__ + "static/media/cheps.0210388b.jpg";